import { Company } from './company.interface';
import { Customer } from './customer.interface';
import { InvoiceInterface } from './invoice.interface';

export interface MoneyCollectionInList {
  id: string;
  paymentType: MONEY_COLLECTION_PAYMENT_TYPE;
  traderType: MONEY_COLLECTION_TRADER_TYPE;
  customer?: Customer;
  value: string;
  date: string;
  serialNumber: number;
  createdAt: string;
}

export interface MoneyCollection extends MoneyCollectionInList {
  companyId: string;
  company: Company;
  customerId: string;
  year: number;
  currentSubtotal: string;
  paycheckBank?: string;
  paycheckNumber?: string;
  paycheckDate?: string;
  notes?: string;
  emailSentToCustomerAt: string;
  invoiceId?: string | null;
  invoice?: InvoiceInterface | null;
  canDelete?: boolean;
  posTransactionDetails?: PosTransactionDetails;
}

export interface PosTransactionDetails {
  success: boolean;
  transactionId?: string; // 8-char string
  provider_data?: string; // Field used to initiate pos transaction
  provider_signature?: string; // Field used to initiate pos transaction
}

export const TRADER_TYPE: Record<number, any> = {
  1: { id: 1, name: 'CUSTOMER', description: '' },
  2: { id: 2, name: 'SUPPLIER', description: '' },
};

export enum MONEY_COLLECTION_PAYMENT_TYPE {
  CASH = 'CASH',
  BUSINESS_BANK_ACCOUNT = 'BUSINESS_BANK_ACCOUNT',
  MONEY_CHECK = 'MONEY_CHECK',
  RETURN_MONEY_CASH = 'RETURN_MONEY_CASH',
  RETURN_MONEY_BANK = 'RETURN_MONEY_BANK',
  RETURN_MONEY_CHECK = 'RETURN_MONEY_CHECK',
  CLEARING = 'CLEARING',
  POS = 'POS',
}

export enum MONEY_COLLECTION_TRADER_TYPE {
  CUSTOMER = 1,
  SUPPLIER = 2,
  TRADER = 3,
}

export const MONEY_COLLECTION_TRADER_TYPE_LABEL: Record<number, string> = {
  1: 'CUSTOMER',
  2: 'SUPPLIER',
  3: 'TRADER',
};
